import { PageRouteBuilder } from "@common/route/page-route-builder";
import { PeopleDashboardPageComponent } from "./people-dashboard-page.component";

export const peopleDashboardPageRoute = new PageRouteBuilder()
    .usingNgComponent("adapt-people-dashboard-page", PeopleDashboardPageComponent)
    .atUrl("/people")
    .withTitle("People")
    .build();
